export default "__VITE_ASSET__DQHZU2Zw__"